import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { GAME_LIVE_IMAGE } from '../../domain/countdown-bar.helpers';
import type { CountdownBarItem } from '../../store/countdown-bar.store';
import { CountdownBarTeamSideComponent } from '../countdown-bar-team-side/countdown-bar-team-side';
import { CountdownBarTimerComponent } from '../countdown-bar-timer/countdown-bar-timer';

@Component({
  selector: 'bingo-countdown-bar-game',
  imports: [CountdownBarTeamSideComponent, CountdownBarTimerComponent],
  templateUrl: './countdown-bar-game.html',
  styleUrl: './countdown-bar-game.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'class': 'countdown-bar__game',
    '[class.is-active]': 'active()',
    '[class.is-live-game]': 'item().state === \'live\'',
    '[class.is-entering]': 'entering()',
    '[class.is-next-entering]': 'nextEntering()',
    '[class.is-removing-live]': 'removingLive()',
    '(click)': 'openGame.emit()',
  },
})
export class CountdownBarGameComponent {
  protected readonly gameLiveImage = GAME_LIVE_IMAGE;
  readonly item = input.required<CountdownBarItem>();
  readonly active = input.required<boolean>();
  readonly transitioning = input.required<boolean>();
  readonly entering = input(false);
  readonly nextEntering = input(false);
  readonly removingLive = input(false);
  readonly openGame = output();
}
